module.exports = __webpack_public_path__ + "static/media/gameVideo6.09ad0b04.mp4";